import templateUrl from 'servicestack/tags/tag-prompt.htm';
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import config from 'servicestack/tags/_config'
import labels from 'servicestack/tags/_labels'
import modals from 'webmodals/modals'

class TagPromptController {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        const req = options.request || {};
        $ctrl.request = Object.assign(
            {
                originalShard: req.shard,
                originalTagKind: req.tagKind,
            },
            req
        );
        $ctrl.bus = new ServiceBus();
        $ctrl.title = options.title || ' Tag Configuration...'
        $ctrl.types = config.types;
        $ctrl.config = config;
        $ctrl.labels = labels;
        console.debug($ctrl);
    }

    submit() {
        const $ctrl = this;
        $ctrl.bus.send(`${$ctrl.request.id ? 'Upd' : 'Cre'}ateTagConfig.json`, $ctrl.request)
            .then(function (response) {
                $ctrl.$close($ctrl.request);
            });
    }
}

const TagPrompt = {
    open(options) {
        return modals.open(Object.assign({
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: TagPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default TagPrompt;